import { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMapEvents, Marker, Popup } from "react-leaflet"
import './map.scss'
import marker from '../../utils/resources/LogoAwC.png';
import { Icon } from 'leaflet'
import { Link } from "react-router-dom";
import { Instalation } from "../../utils/models/Instalation";
const myIcon = new Icon({
    iconUrl: marker,
    iconSize: [32, 32]
})

export interface IPosPoint {
    lat: number;
    lng: number;
}

const MapComponent = (props: { position: IPosPoint, setPosition: (p: IPosPoint) => void, enable: boolean, showAllContainers: boolean, allContainers: Instalation[] }) => {

    const [centerPos, setCenterPos] = useState<IPosPoint | null>(null)

    useEffect(() => {
        if (props.position) {
            setCenterPos({ lat: props.position.lat, lng: props.position.lng })
        }
    }, [props])

    const Markers = () => {
        useMapEvents({
            click(e) {
                if (!props.enable) {
                    setCenterPos({ lat: e.latlng.lat, lng: e.latlng.lng });
                    props.setPosition({ lat: e.latlng.lat, lng: e.latlng.lng })
                }

            },
        })

        return (
            centerPos ?
                <Marker
                    icon={myIcon}
                    position={centerPos}
                    interactive={false}
                />
                : null
        )
    }

    return (
        <MapContainer center={[props.position.lat, props.position.lng]} zoom={props.showAllContainers ? 6 : 10}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {!props.showAllContainers && <Markers />}
            {props.showAllContainers ? props.allContainers.map((c, i) => (
                <Marker key={i} icon={myIcon} position={[c.lat, c.lng]}>
                    <Popup>
                        <Link to={`/userCanteens/${c.idinstalation}`}>
                            <i className={'bi bi-geo-alt'}></i>
                            <span className='ms-4'>{c.name}</span>
                        </Link>
                    </Popup>
                </Marker>)) : null}
        </MapContainer>
    )

}

export default MapComponent